import { filterBy, getPropsFromUrl } from 'components/hoc/index';
import { EnhancedSider } from 'components/page/index';
import { FloatingLabelInput } from 'components/ui/index';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { emptyFn } from 'utils/common';
import { tryFetchColumns } from '../../../flow/actions';
import DropZone from '../components/DropZone';


const propTypes = {
  handleFilterChange: PropTypes.func.isRequired,
};

class LeftSider extends PureComponent {
  componentDidMount() {
    const { tryFetchColumns, objectType, reportId } = this.props;
    if (objectType) {
      tryFetchColumns(objectType, reportId);
    }
  }

  render() {
    const { handleFilterChange, filterText, filteredData } = this.props;
    const i18n = 'page.ReportSetup.leftSider';
    // Notes: resort order to avoid left sider data change order when user change order on right zones
    const filteredDataCopy = _.cloneDeep(filteredData);
    const sortedData = _.sortBy(filteredDataCopy, ['label']);

    return (
      <EnhancedSider style={{ padding: '20px 10px' }}>
        <FloatingLabelInput
          value={filterText}
          handleChange={handleFilterChange}
          labelText={<FormattedMessage id={`${i18n}.search`} />}
          handleSearch={emptyFn}
          withSearch
        />
        <div
          className="text-center mb-md mt-md"
          style={{
            background: '#ffffd9',
            border: '0.8px solid #e2bc24',
            lineHeight: '38px'
          }}>
          <FormattedMessage id={`${i18n}.tip`} />
        </div>
        <DropZone filteredData={sortedData} />
      </EnhancedSider >
    );
  }
}

LeftSider.propTypes = propTypes;
const mapStateToProps = ({ reportSetup, global }) => ({
  lang: global.language,
  data: reportSetup.sider.availableColumns,
});
const mapDispatchToProps = {
  tryFetchColumns,
};
const enhancers = compose(
  getPropsFromUrl(['objectType', 'reportId']),
  connect(mapStateToProps, mapDispatchToProps),
  filterBy(
    'data',
    (record, i, collection, value) => record.label.toLowerCase().indexOf(value.toLowerCase()) > -1,
  ),
);
export default enhancers(LeftSider);



// WEBPACK FOOTER //
// ./src/views/ReportSetup/components/LeftSider/container/index.jsx